import { render, staticRenderFns } from "./AddMerchant.vue?vue&type=template&id=761edd04"
import script from "./AddMerchant.vue?vue&type=script&lang=js"
export * from "./AddMerchant.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports